export default "__VITE_ASSET__CUNWLnXS__"